<template>
	<div
		class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg divide-y divide-gray-200"
	>
		<!-- header / sorting -->
		<div
			class="bg-gray-50 grid grid-cols-5 lgr:grid-cols-7 p-3 gap-x-3 gap-y-2"
		>
			<div
				v-for="sortOption in sortOptions"
				:key="sortOption.sortBy"
				v-on:click="toggleSortOption(sortOption)"
				class="text-xs font-medium text-gray-500 uppercase tracking-wider flex cursor-pointer"
				:class="sortOption.cssClass"
			>
				<span class="truncate">{{ sortOption.label }}</span>

				<ui-icon
					v-if="sortOption.sortBy === sortBy"
					class="ml-1 flex-shrink-0 h-4 w-4 -mr-1"
					:name="sortOrder == 1 ? 'arrow-down' : 'arrow-up'"
					:stroke-width="2"
				/>
			</div>
		</div>

		<!-- rows -->
		<ul class="bg-white divide-y divide-gray-200">
			<paper-offers-list-item
				v-for="(offer, idx) in sortedOffers"
				:key="idx"
				:offer="offer"
				:trade="trade"
				v-on:edit-offer="propagateEditOffer"
			/>
			<li class="p-3" v-if="!sortedOffers.length">
				<div class="font-italic text-gray-400">{{ __("No match") }}</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		trade: {
			type: String,
			required: true,
		},
		offers: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			sortBy: "price.mt",
			sortOrder: this.trade == "buy" ? -1 : 1,
			sortOptions: [
				{
					label: this.__("Latest"),
					sortBy: "updated_at",
					sortOrder: 1,
					cssClass: "col-span-2",
				},
				{
					label: this.__("Fulfilment Date"),
					sortBy: "date.month_to",
					sortOrder: 1,
				},
				{
					label: this.__("Quantity"),
					sortBy: "qty.mt",
					sortOrder: 1,
				},
				{
					label: this.__("Market"),
					sortBy: "location.hub",
					sortOrder: 1,
				},
				{
					label: this.__("Premium"),
					sortBy: "price.basis",
					sortOrder: this.trade == "buy" ? -1 : 1,
					cssClass: "col-start-3 lgr:col-start-6",
				},
				{
					label: this.__("Price"),
					sortBy: "price.mt",
					sortOrder: this.trade == "buy" ? -1 : 1,
				},
			],
		};
	},
	computed: {
		sortedOffers() {
			let that = this,
				ret = this.offers;
			return ret.sort(function (a, b) {
				let aVal = that.deepValue(a, that.sortBy),
					bVal = that.deepValue(b, that.sortBy);
				// try to put null values to the end
				if (aVal === null) {
					return 1;
				}
				if (bVal === null) {
					return -1;
				}
				if (typeof aVal == "string" && typeof bVal == "string") {
					return aVal.localeCompare(bVal) * that.sortOrder;
				} else {
					return (aVal - bVal) * that.sortOrder;
				}
			});
		},
	},
	methods: {
		propagateEditOffer(offer) {
			this.$emit("edit-offer", offer);
		},
		deepValue(obj, path) {
			return path
				.replace(/\[|\]\.?/g, ".")
				.split(".")
				.filter((s) => s)
				.reduce((acc, val) => acc && acc[val], obj);
		},
		toggleSortOption(sortOption) {
			if (sortOption.sortBy != this.sortBy) {
				this.sortBy = sortOption.sortBy;
				this.sortOrder = sortOption.sortOrder;
			} else {
				this.sortOrder = -1 * this.sortOrder;
			}
		},
	},
};
</script>
